import { Component, inject } from '@angular/core';
import { SpecificConsumptionTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SpecificConsumptionTypeCreateDto,
  SpecificConsumptionTypeDto,
  SpecificConsumptionTypeExcelDownloadDto,
  SpecificConsumptionTypeUpdateDto,
} from '../proxy/planning/dtos/specific-consumption-type';
import { SPECIFICCONSUMPTIONTYPE_CONFIG, SPECIFICCONSUMPTIONTYPE_FIELDS } from './specific-consumption-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-specific-consumption-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SpecificConsumptionTypeService, ConfirmationService],
  templateUrl: './specific-consumption-type.html',
  styleUrl: './specific-consumption-type.scss',
})
export class SpecificConsumptionType extends BaseCrudComponent<
  SpecificConsumptionTypeDto,
  SpecificConsumptionTypeCreateDto,
  SpecificConsumptionTypeUpdateDto,
  SpecificConsumptionTypeExcelDownloadDto
> {
  service = inject(SpecificConsumptionTypeService);
  config = SPECIFICCONSUMPTIONTYPE_CONFIG;
  fields = SPECIFICCONSUMPTIONTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SpecificConsumptionTypeDto): SpecificConsumptionTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SpecificConsumptionType';
  }
}
